<template>
  <div>
    <new-help-list-ajax :titleText="title"></new-help-list-ajax>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

import NewHelpListAjax from '@/components/NewHelpListAjax.vue';

export default {
  name: 'Help3',
  components: {
    NewHelpListAjax,
  },
  data() {
    return {
      title: PUBLIC_EMPTY_TITLE === '1' ? '意见反馈' : '帮助和反馈',
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'newhelpdetailajax') {
      this.$store.commit('setCache', 'Help3');
    } else {
      this.$store.commit('delCache', 'Help3');
    }
    next();
  },
};
</script>
